import PropTypes from 'prop-types';
import React from 'react';

import { TYPES } from 'constants/topNavigation';

import Level3OptionText from './Level3OptionText';

const Level3Option = ({ l1Label, l2Label, l3Option, trackNavigation, trackNavigationClick }) => {
  const handleClick = () => {
    trackNavigation(l3Option.linkUrl);
    trackNavigationClick({
      navigationType: TYPES.LEVEL_3,
      navigationLevel1: l1Label,
      navigationLevel2: l2Label,
      navigationLevel3: l3Option.label,
      navigationSource: window.location.href,
    });
  };

  return (
    <>
      <Level3OptionText
        title={l3Option.label}
        href={l3Option.linkUrl}
        onClick={() => handleClick()}
      />
    </>
  );
};

Level3Option.propTypes = {
  l1Label: PropTypes.string.isRequired,
  l2Label: PropTypes.string.isRequired,
  l3Option: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  trackNavigation: PropTypes.func.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
};

export default Level3Option;
